import { Injectable, ComponentRef } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ProgressOverlayComponent } from './shared/common/progress-overlay/progress-overlay.component';
import { ComponentPortal } from '@angular/cdk/portal';

@Injectable({
    providedIn: 'root'
})
export class ProgressService {
    private progressOverlayRef: OverlayRef | null = null;
    private componentRef: ComponentRef<ProgressOverlayComponent> | null = null;

    constructor(private overlay: Overlay) { }

    show(initalMessage: string = 'Loading Data') {
        if (this.progressOverlayRef) return; // Don't overwrite whatever is currently displayed

        this.progressOverlayRef = this.overlay.create({
            hasBackdrop: true,
            backdropClass: 'progress-service-backdrop',
            positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically()
        });

        let portal = new ComponentPortal(ProgressOverlayComponent);
        this.componentRef = this.progressOverlayRef.attach(portal);
        this.componentRef.instance.message = initalMessage;
        this.componentRef.instance.progress = 0;
    }

    hide() {
        if (this.progressOverlayRef) {
            this.progressOverlayRef.detach();
            this.progressOverlayRef.dispose();
            this.progressOverlayRef = null;
            this.componentRef = null;
        }
    }

    updateProgress(newValue: number) {
        if (this.progressOverlayRef) {
            this.componentRef.instance.progress = newValue;
        }
    }

    getProgressNumber(): number {
        if (this.progressOverlayRef) {
            return this.componentRef.instance.progress;
        }

        return -1;
    }

    updateMessage(newMessage: string) {
        if (this.progressOverlayRef) {
            this.componentRef.instance.message = newMessage;
        }
    }
}
